import React from 'react';

// Crescent + star mark, inspired by the Libyan Flag Company letterhead
// (steel-blue crescent with an overlapping five-point star).
export default function Logo({ size = 40, mono = false }) {
  const crescentFill = mono ? '#ffffff' : '#5b9bd5';
  const starFill = mono ? '#ffffff' : '#2f6690';
  const cutout = mono ? 'transparent' : '#ffffff';

  const starPoints = [
    [0, -9],
    [2.0, -2.75],
    [8.56, -2.78],
    [3.23, 1.05],
    [5.29, 7.28],
    [0, 3.4],
    [-5.29, 7.28],
    [-3.23, 1.05],
    [-8.56, -2.78],
    [-2.0, -2.75],
  ]
    .map((p) => p.join(','))
    .join(' ');

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Libyan Flag Company logo"
    >
      <circle cx="27" cy="33" r="18" fill={crescentFill} />
      <circle cx="34" cy="28" r="14.5" fill={cutout} />
      <polygon points={starPoints} fill={starFill} transform="translate(41,25) rotate(12) scale(0.82)" />
    </svg>
  );
}
